import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableContainer, Paper } from '@mui/material';
import FinancialProductSeasonalityTemplatesTableHead from './FinancialProductSeasonalityTemplatesTableHead';
import FinancialProductSeasonalityTemplatesTableBody from './FinancialProductSeasonalityTemplatesTableBody';
import PropTypes from 'prop-types';
import Placeholder from 'components/common/Placeholder';

const FinancialProductSeasonalityTemplatesTable = ({
  canWrite,
  seasonalityTemplates,
  onAdd,
  onEdit,
  onChangeData,
  onCloseEdit,
  onSave,
  onDelete,
  isSaved,
  lockControls,
  financialProductSeasonalityTemplatesDictionary,
  financialProductSeasonalityTemplatesValidation
}) => {
  const [t] = useTranslation();

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <FinancialProductSeasonalityTemplatesTableHead canWrite={canWrite} isSaved={isSaved} onAdd={onAdd} lockControls={lockControls} />
          {isSaved && (
            <FinancialProductSeasonalityTemplatesTableBody
              canWrite={canWrite}
              seasonalityTemplates={seasonalityTemplates}
              onEdit={onEdit}
              onChangeData={onChangeData}
              onCloseEdit={onCloseEdit}
              onSave={onSave}
              onDelete={onDelete}
              lockControls={lockControls}
              financialProductSeasonalityTemplatesDictionary={financialProductSeasonalityTemplatesDictionary}
              financialProductSeasonalityTemplatesValidation={financialProductSeasonalityTemplatesValidation}
            />
          )}
        </Table>
      </TableContainer>
      {isSaved && seasonalityTemplates?.length === 0 && <Placeholder message={t('TableIsEmpty')} color={'gray'} />}
    </>
  );
};

FinancialProductSeasonalityTemplatesTable.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  seasonalityTemplates: PropTypes.array.isRequired,
  onAdd: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onCloseEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onChangeData: PropTypes.func.isRequired,
  isSaved: PropTypes.bool.isRequired,
  lockControls: PropTypes.bool.isRequired,
  financialProductSeasonalityTemplatesDictionary: PropTypes.array.isRequired,
  financialProductSeasonalityTemplatesValidation: PropTypes.object.isRequired
};

export default FinancialProductSeasonalityTemplatesTable;
